import Vue from "vue";
import App from "./App.vue";
import axios, { AxiosError } from "axios";
import VueAxios from "vue-axios";
import "./registerServiceWorker";
import "es6-promise/auto";
import vuetify from "@/plugins/vuetify";
import router from "@/router";
import store from "@/state/store";
import ApiHelper, { ApiEvents } from "@/api/apiHelper";
import VueClipboard from "vue-clipboard2";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

// Copy to Clipboard
Vue.use(VueClipboard);
Vue.config.productionTip = false;

// Sentry
Sentry.init({
  Vue,
  dsn: "https://eed561d39ee94ddab1647b13bd94aa0b@o494993.ingest.sentry.io/6639174",
  environment: "production",
  tracingOptions: {
    trackComponents: true,
  },
  debug: false,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "app.oneclick.fi", "beta.onebutton.trade", "feature.onebutton.trade", /^\//],
    }),
  ],
  tracesSampleRate: 1.0,
});

// API Handling
Vue.use(VueAxios, axios);
Vue.prototype.$api = new ApiHelper();
Vue.prototype.$api.on(ApiEvents.Error, (error: AxiosError) => {

  if (error.response?.status === 502) {
    return;
  }

  if (error.response?.data.description != null) {
    store.dispatch(
      "publishSnackbarErrorEvent",
      error.response?.data.description
    );
    return;
  }
  if (error.response?.data.error != null) {
    if (error.response?.data.error.includes("Failed to authenticate")) {
      return;
    }
    store.dispatch("publishSnackbarErrorEvent", error.response?.data.error);
    return;
  } else {
    store.dispatch("publishSnackbarErrorEvent", typeof error === "string" ? error : error.response?.data);
  }
});



// App Initiation
new Vue({
  store,
  router: router,
  vuetify: vuetify as any,
  render: (h) => h(App),
}).$mount("#app");
